import { SourceOfFundsFormJson } from '../../../api/AccountService.schemas';
import { OptionsMap, SOF_QUESTIONS_CONFIG, TitleMap } from '../SOF.constants';
import { SOFPayload } from '../SOF.types';

export const buildRequestData = (payload: SOFPayload) =>
  Object.keys(payload).map((questionId) => {
    const { title } = SOF_QUESTIONS_CONFIG[questionId];

    return {
      question: TitleMap[title] ?? '',
      questionId,
      answers: Object.keys(payload[questionId]).reduce(
        (accumulator: SourceOfFundsFormJson['answers'], controlId) => {
          const { answer, ...rest } = payload[questionId][controlId];

          if (!answer) {
            return accumulator;
          }

          return [
            ...accumulator,
            {
              answer: OptionsMap[answer] ?? answer.trim(),
              ...rest,
            },
          ];
        },
        [],
      ),
    };
  });
